module.exports = __webpack_public_path__ + "img/PersonImage.bba1a6e3.svg";